const primaryMain = '#006648';
const primaryMainOpacity = 'rgba(0, 40, 28, 0.9)';
const secondaryMain = '#6BC04B';
const secondaryMainOpacity = 'rgba(42, 75, 29, 0.5)';
const secondaryLight = '#1F6D50';
const tertiaryMain = '#85C56C';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
